import ReactDOM from "react-dom";
import { TransverseLoading } from "react-loadingg";

const Spinner = ({ fullScreen, color }) => {
  const content = (
    <div
      className={` 
      flex justify-center items-center 
      [&>div>div]:mt-0! [&>div]:h-fit! [&>div]:w-fit! [&>div]:relative!
      ${
        fullScreen
          ? " fixed z-100 w-full h-[calc(100vh-47px)] left-0 top-[48px]! bg[rgba(255,255,255,0.05)] backdrop-blur[1px] cursor-not-allowed "
          : " absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-fit w-fit z-50"
      }
      `}
    >
      <TransverseLoading color={color || "#1C69FB"} size={fullScreen ? "large" : "small"} />
    </div>
  );

  if (fullScreen) {
    const target = document.getElementById("custom-spinner");
    if (!target) return null;
    // Our <Portal/> component has some issues. It was not loading in Table
    return ReactDOM.createPortal(content, target);
  }

  return content;
};

export default Spinner;
